var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#AFAFB1",
    strokeWidth: 2,
    className: "arrow-right_svg__toggle",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6h10M8 2l4 4-4 4"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcKICB3aWR0aD0iMTRweCIKICBoZWlnaHQ9IjEycHgiCiAgdmlld0JveD0iMCAwIDE0IDEyIgogIHZlcnNpb249IjEuMSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCj4KICAgIDxnCiAgICBpZD0i4pyFLUZlYXRoZXItKE5ldXRyYWwpIgogICAgc3Ryb2tlPSJub25lIgogICAgc3Ryb2tlLXdpZHRoPSIxIgogICAgZmlsbD0ibm9uZSIKICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiCiAgPgogICAgICAgIDxnCiAgICAgIGlkPSJDb2NrcGl0IgogICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjUxLjAwMDAwMCwgLTg3NC4wMDAwMDApIgogICAgICBzdHJva2U9IiNBRkFGQjEiCiAgICAgIHN0cm9rZS13aWR0aD0iMiIKICAgICAgY2xhc3M9InRvZ2dsZSIKICAgID4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMi4wMDAwMDAsIDg3MS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJhcnJvdy1yaWdodCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQwLjAwMDAwMCwgNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCw0IEwxMCw0IiBpZD0iUGF0aCIgLz4KICAgICAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlBhdGgiIHBvaW50cz0iNyAwIDExIDQgNyA4IiAvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };